import { faLock } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Colours, Icon } from "@/shared/coralreef";
import { Screen, ScreenBody, ScreenTitle } from "./Screen";

export interface QuickLoginPromptProps {
  onSetUp(): void;
  onNotNow(): void;
  disabled?: boolean;
}

export const QuickLoginPrompt: React.FC<QuickLoginPromptProps> = ({
  onSetUp,
  onNotNow,
  disabled,
}) => {
  const { t } = useTranslation();
  return (
    <Screen testId="login-quick-login-prompt">
      <div className="flex h-12 w-12 items-center justify-center rounded-[5px] bg-observe-light">
        <Icon icon={faLock} color={Colours.primary} />
      </div>
      <ScreenTitle>{t("Set up quick login?")}</ScreenTitle>
      <ScreenBody>
        {t(
          "Skip typing your password next time — sign in with a 4-digit PIN on this device.",
        )}
      </ScreenBody>
      <div className="flex gap-2.5">
        <div className="flex-1">
          <Button
            content={t("Set up PIN")}
            data-testid="quick-login-prompt-setup-button"
            appearance="blue"
            onClick={onSetUp}
            disabled={disabled}
            fullWidth
          />
        </div>
        <div className="flex-1">
          <Button
            content={t("Not now")}
            data-testid="quick-login-prompt-skip-button"
            appearance="hollow"
            onClick={onNotNow}
            disabled={disabled}
            fullWidth
          />
        </div>
      </div>
    </Screen>
  );
};
